import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RichmenuMaintenance from 'pages/lexus/RichmenuMaintenance';
import TechIntroMaintenance from 'pages/lexus/TechIntroMaintenance';
import BroadcastMaintenance from 'pages/lexus/BroadcastMaintenance';
import ShowRoomMaintenance from 'pages/lexus/ShowRoomMaintenance';
import CampaignMaintenance from 'pages/lexus/CampaignMaintenance';
import MemberTagSearch from 'pages/lexus/MemberTagSearch';

const LexusRouter = () => {
    return (
        <Routes>
            <Route path="/RichmenuMaintenance" element={<RichmenuMaintenance />} />
            <Route path="/TechIntroMaintenance" element={<TechIntroMaintenance />} />
            <Route path="/BroadcastMaintenance" element={<BroadcastMaintenance />} />
            <Route path="/ShowRoomMaintenance" element={<ShowRoomMaintenance />} />
            <Route path="/CampaignMaintenance" element={<CampaignMaintenance />} />
            <Route path="/MemberTagSearch" element={<MemberTagSearch />} />
        </Routes>
    );
};

export default LexusRouter;